module.exports = __webpack_public_path__ + "static/media/home-built-for-teachers-icon.40cd8945.png";